export default class Notification {
  static SERVICE_NAME = 'notification';

  constructor({ app, store }) {
    this.axios = {
      withToken() {
        return app.$axios.create({
          baseURL : process.env.NOTIFICATION_API,
          headers : {
            Accept            : 'application/json',
            'Content-Type'    : 'application/json',
            'x-api-key'       : process.env.NOTIFICATION_API_KEY,
            'x-user-timezone' : store.state._core.user.timezone,
            Authorization     : app.$token.get()
          }
        });
      }
    };
  }

  getAllNotification({ page, perPage = 10, displayMode, isRead }) {
    const params = { page: page || 1, perPage, displayMode, isRead };
    return this.axios.withToken().get('/notifications?deliveryMode=application', { params });
  }

  updateNotificationRecipients(id, body) {
    return this.axios.withToken().patch(`/recipients/${id}`, body);
  }

  updateSetReadAllNotification() {
    return this.axios.withToken().patch('/recipients/read-all', { deliveryMode: 'application' });
  }
}
